export default function revealHiddenDoor(st) {
  console.log("revealHiddenDoor");
  st.Buttons.type = "hiddenDoor";
}
